<div class="row justify-content-between justify-content-md-start">
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Monthly Active Users"
        tooltipValue="Unique programmatic users on mobile in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.programmaticMau | round | roundsig}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Total Sessions"
        tooltipValue="Total programmatic sessions from mobile ad activity in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.totalSessions | round | roundsig}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Sessions per User"
        tooltipValue="Average programmatic sessions per user on mobile over the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.sessionsPerUser | rounddecimal:1}}
    </h3>
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 titleName="Session Duration"
        tooltipValue="Average programmatic time spent per session on mobile in the last 30 days."></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.sessionDuration | duration: 'ms':'mmss'}}
    </h3>
  </div>
</div>